export default __webpack_public_path__ + "static/media/classes.d7a97d12.svg";